
import { IconAvatar } from '@ds/icons/IconAvatar'
import { IconBill } from '@ds/icons/IconBill'
import { IconPromo } from '@ds/icons/IconPromo'

import NumberedSteps from '@core/components/NumberedSteps'

import translations from './Steps.translations'

export default {
  components: {
    NumberedSteps,
  },
  computed: {
    steps() {
      return [
        {
          icon: IconAvatar,
          text: this.$t(translations.step1),
        },
        {
          icon: IconBill,
          text: this.$t(translations.step2),
        },
        {
          icon: IconPromo,
          text: this.$t(translations.step3),
        },
      ]
    },
  },
}
